import React from "react";
import styled from "styled-components";

const DRIVE_LINK = "https://drive.google.com/drive/folders/1eb6FfJtDavSmW53j3k4-UqG4y0wZCZXp?usp=drive_link";

const Page = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.body};
`;

const DriveButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #05505E;
  color: #ffffff;
  font-size: 36px;
  text-decoration: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }
`;

export default function Root({ theme }) {
  return (
    <Page theme={theme}>
      <DriveButton href={DRIVE_LINK} target="_blank" rel="noopener noreferrer">
        <i className="fab fa-google-drive"></i>
      </DriveButton>
    </Page>
  );
}
